var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--about-us_learn-more-about-airalo new-container mx-auto"
  }, [_c('div', {
    staticClass: "learn-more-about-airalo mt-20 mt-md-30 mt-lg-40"
  }, [_c('nuxt-img', {
    staticClass: "learn-more-about-airalo-img",
    attrs: {
      "src": "/assets/images/about-us/about-us-learn-more-banner.jpg",
      "width": "1132",
      "heigth": "408",
      "alt": "",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "learn-more-about-airalo-texts"
  }, [_c('h2', {
    staticClass: "learn-more-about-airalo-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "learn-more-btn call-to-action light no-outline",
    attrs: {
      "to": _vm.link ? _vm.localePath(_vm.link) : _vm.localePath(_vm.learnMoreLink)
    },
    nativeOn: {
      "click": function ($event) {
        _vm.sendEventHandler({
          text: _vm.$t('scenes.about.us.learn-more-button-title'),
          url: _vm.link ? _vm.localePath(_vm.link) : _vm.localePath(_vm.learnMoreLink)
        });
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('scenes.about.us.learn-more-button-title')) + "\n      ")])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }